import api from './api';

const municipioService = {
  getAllMunicipios: async () => {
    const response = await api.get('/municipio');
    return response.data.data;
  },
};

export default municipioService;
